/**
 * region for libraries*/
import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Checkbox, FormControlLabel, Tooltip, IconButton, Menu, MenuItem } from '@material-ui/core';
import { Info, Tune } from '@material-ui/icons';

class MenuFiltersKeyword extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            anchorEl : null
        }
    }
    
    handleClick(event) {
        this.setState({ anchorEl : event.currentTarget });
    };

    handleClose(){
        this.setState({ anchorEl: null });
    };

    render() {
        const { classes } = this.props;
        const { anchorEl } = this.state;
        
        return (

            <Fragment>
                <IconButton
                    className={classes.button}
                    aria-label="more"
                    aria-controls="long-menu"
                    aria-haspopup="true"
                    onClick={this.handleClick.bind(this)}>
                    <Tune />
                </IconButton>
                <Menu
                    id="long-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    PaperProps={{
                        style: {
                            marginTop: '35px',
                        }
                    }}
                    onClose={this.handleClose.bind(this)}>
                    
                        <MenuItem key="checkInsufficientContent" >
                            <FormControlLabel className="m-0 mr-1" control={
                                <Checkbox
                                    className="p-0"
                                    color="primary"
                                    checked={this.props.checkInsufficientContent}
                                    onChange={this.props.handleChangeCheckInsufficientContent}
                                />
                                }
                                label="Insufficient content"
                            />
                            <Tooltip title="Use the 'Insufficient content' filter to display keywords with less than 2 total results across all web product types. For instance, a keyword with results split as 5 in products and 0 in services won't show. But one with 1 in products, 1 in services, and 1 in software will be displayed. This filter works in conjunction with other filters you've selected." className="m-0 mr-2">
                                <IconButton size="small" variant="outlined">
                                    <Info fontSize="inherit"/>
                                </IconButton>
                            </Tooltip>
                        </MenuItem>
                        
                        <MenuItem key="checkEqualToCategory">
                            <FormControlLabel className="m-0 mr-1" control={
                                <Checkbox
                                    className="p-0"
                                    color="primary"
                                    checked={this.props.checkEqualToCategory}
                                    onChange={this.props.handleChangeCheckEqualToCategory}
                                />
                                }
                                label="Equal to a category"
                            />
                            <Tooltip title="Use the 'Equal to a category' filter to display keywords that have the same name as a L2 category. This filter works in conjunction with other filters you've selected." className="m-0 mr-2">
                                <IconButton size="small" variant="outlined">
                                    <Info fontSize="inherit"/>
                                </IconButton>
                            </Tooltip>
                        </MenuItem>
                    
                </Menu>
            </Fragment>

        );
    }
}
MenuFiltersKeyword.propTypes = {
    classes: PropTypes.object.isRequired
};
export default withStyles()(MenuFiltersKeyword);